import { PIPE_MARKET_PARTNER_ID } from './wo2894Entry';

export const WELL_REPD_PARTNER_ID = '6ad8ac03-049f-462f-83fc-8b2bbc7c5bdd';

export const personaPreferenceKey = (userId) => `charlie.default_persona.${userId}`;

export function readDefaultPersona(userId, storage = typeof localStorage !== 'undefined' ? localStorage : null) {
  if (!userId || !storage) return null;
  try { return storage.getItem(personaPreferenceKey(userId)) || null; } catch (e) { return null; }
}

export function saveDefaultPersona(userId, partnerId, storage = typeof localStorage !== 'undefined' ? localStorage : null) {
  if (!userId || !partnerId || !storage) return false;
  try { storage.setItem(personaPreferenceKey(userId), partnerId); return true; } catch (e) { return false; }
}

export function defaultEntryPartner({ hash, partners = [], userId, storage, canAccessPartner = () => true } = {}) {
  const path = String(hash || '').replace(/^#\/?/, '').split('?')[0];
  if (!['', 'home', 'dashboard'].includes(path)) return null;
  const usable = (p) => p && p.active !== false && !p.hide_from_switcher;
  // Shane 2026-10-27: Charlie opens on Well Repd (the personal dashboard) whenever the user can access it; a saved default only applies to people who cannot.
  const wellRepd = partners.find((p) => p.id === WELL_REPD_PARTNER_ID);
  if (usable(wellRepd) && canAccessPartner(wellRepd) === true) return wellRepd;
  const savedId = readDefaultPersona(userId, storage);
  const saved = savedId && partners.find((p) => p.id === savedId);
  if (usable(saved) && canAccessPartner(saved) === true) return saved;
  const pipe = partners.find((p) => p.id === PIPE_MARKET_PARTNER_ID);
  return usable(pipe) && canAccessPartner(pipe) === true ? pipe : null;
}
